import { spawn } from 'redux-saga/effects';
import addressAutocompleteSaga from '../components/AddressAutocomplete/addressAutocompleteSaga';
import cartSaga from '../features/cart/cartSaga';
import notificationSaga from '../features/notifications/notificationSaga';

function* campaignPageSaga() {
    yield spawn(addressAutocompleteSaga);
    yield spawn(cartSaga);
    yield spawn(notificationSaga);
}

export default campaignPageSaga;
